/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

export default undefined;

/**
 * URL adresa.
 * @typedef {string} Url
 */

/**
 * Zkontroluje, zda-li je URL validní
 * a případně vyhodí chybu.
 * @param {string} url
 * @returns {URL}
 * @throws {AssertionError}
 */
export function parseURL(url) {
  try {
    return new URL(url);
  } catch {
    throw new TypeError(`Invalid URL ${JSON.stringify(url)}.`);
  }
}
